import { protocolType } from "@/config/protocol";
import CommonLayout from "@/layout/frame/common";
import ContentFrame from "@/layout/frame/content-frame";
import { containsAny, contentFramePath } from "@/utils";
import { useRouter } from "next/router";

const typeArr = [].concat(...(protocolType as any));

export const FrameComponent = (props: any): JSX.Element => {
  const { pathname, query, push } = useRouter();

  const isContentRouter = containsAny(pathname, contentFramePath);

  if (isContentRouter && query.type) {
    const hashType = containsAny(query.type as string, typeArr);

    // 如果匹配不上路由类型，则跳转到404页面
    if (!hashType && typeof window !== "undefined") {
      push(`/404`);
    }
  }

  // 有些页面不需要公共头部和底部
  return isContentRouter ? <ContentFrame {...props} /> : <CommonLayout {...props} />;
};
